import { Typography, TypographyProps } from '@mui/joy';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import { parseString } from 'core/utils';
import { Color, Level } from 'theme/enums';

interface IProps extends TypographyProps {
  text: string;
  highlight: string;
  highlightColor?: Color;
}

export const TextHighlighter = ({
  text,
  highlight,
  highlightColor = Color.PRIMARY,
  level = Level.BODY_SM,
  ...rest
}: IProps) => {
  if (!text) {
    return null;
  }

  const matches = match(text, highlight, {
    insideWords: true,
    findAllOccurrences: true,
  });

  const parsedText = parse(parseString(text), matches);

  return (
    <Typography level={level}>
      {parsedText?.map((textPart: { highlight: boolean; text: string }, index: number) => (
        <Typography
          key={index}
          level={level}
          {...getHighlightedProps(textPart.highlight, highlightColor)}
          {...rest}
        >
          {textPart.text}
        </Typography>
      ))}
    </Typography>
  );
};

const getHighlightedProps = (highlighted: boolean, color: Color) => {
  if (!highlighted) {
    return {};
  }

  return {
    color,
    fontWeight: 600,
  };
};
